import { FC } from 'react';
import { Input } from 'antd';

import { CodeInputMobileStyled } from './CodeInputMobile.styles';

interface Props {
	code: string[];
	updateCode: (newCode: string) => void;
}

export const CodeInputMobile: FC<Props> = ({ code, updateCode }) => (
	<CodeInputMobileStyled>
		<Input
			maxLength={9}
			value={code.join(``)}
			type='tel'
			pattern='[0-9]{3}-[0-9]{2}-[0-9]{3}'
			onKeyPress={e => {
				if (e.charCode < 48 || e.charCode > 57) {
					e.preventDefault();
				}
			}}
			onChange={e => updateCode(e.target.value)}
		/>
	</CodeInputMobileStyled>
);
